import { createSlice } from "@reduxjs/toolkit";

import { walletsApi } from "../services/wallets";
import type { RootState } from "../../store";
import type { Wallet } from "../../types/WalletTypes";

type WalletsState = {
  list: Wallet[] | [];
};

const initialState: WalletsState = {
  list: [],
};

const walletsSlice = createSlice({
  name: "wallets",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        walletsApi.endpoints.getWallets.matchFulfilled,
        (state, { payload }) => {
          state.list = payload.results;
        }
      )
      .addMatcher(
        walletsApi.endpoints.addWallet.matchFulfilled,
        (state, { payload }) => {
          state.list = [payload, ...state.list];
        }
      );
  },
});

export default walletsSlice.reducer;

export const selectWallets = (state: RootState) => state.wallets.list;
